An array of suggested application questions for the provided partial `PositionProfile` in decreasing order of relevance.

A maximum of 10 application questions can be recommended.

This query accepts browser tokens that include the `query:application-library-question-suggestions` or `query:enhanced-job-posting` scope.
